module.exports = __webpack_public_path__ + "img/signatures.600adf22.png";